import { render, staticRenderFns } from "./SignUp2Form.vue?vue&type=template&id=cf1461de&"
import script from "./SignUp2Form.vue?vue&type=script&lang=js&"
export * from "./SignUp2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports